/**
 * The one locale every date and time in the app is written in.
 *
 * The interface is English, so dates are too, whatever language the viewer's
 * browser or phone is set to. Left to the default, `Intl` follows the device
 * and a German phone shows "Donnerstag, 1. Oktober" above an English agenda.
 * British English for the day-before-month order and the 24-hour clock.
 */
export const APP_LOCALE = "en-GB";
